import { select } from '@js/util/select'

// Pause video when out of view to spare computation cycles
select('.hero-section.hero-is-video', element => {
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const video = entry.target.querySelector('video')
      if (!video) continue
      if (entry.isIntersecting) {
        video.play()
      } else {
        video.pause()
      }
    }
  })
  observer.observe(element)

  return () => {
    observer.unobserve(element)
  }
})
